module.exports = __webpack_public_path__ + "img/quickresume5.bb2b464b.png";